// Jurídico — contratos (2026-08-20).
//
// Duas abas com a mesma lista e perguntas diferentes: **Contratos** responde
// "o que a empresa assinou"; **Vigências**, "o que exige decisão nos próximos
// 90 dias". A segunda é a que evita o caso caro: contrato com renovação
// automática que se renova sozinho porque ninguém avisou a tempo.
//
// O contrato que nós redigimos usa o MESMO motor dos expedientes — numeração
// travada, sigilo por participante, assinatura D4Sign, PDF com timbre e a Pam.
// Contrato de terceiro é um documento do acervo com uma ficha em cima. A ficha
// é o que as duas origens têm em comum, e é o que esta tela lista e vigia.
import { useState } from 'react';
import { App as AntApp, Typography, Tabs } from 'antd';
import { PainelContratos } from './juridico-contratos/PainelContratos';

const { Title, Text } = Typography;

export default function JuridicoContratos() {
  const [aba, setAba] = useState('contratos');

  return (
    <AntApp>
      <div style={{ padding: 16 }}>
        <Title level={4} style={{ marginBottom: 2 }}>⚖️ Contratos</Title>
        <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 16 }}>
          Instrumentos que a Hydrodata assina: os que nós redigimos (com número, assinatura
          digital e timbre) e os que recebemos de terceiros. Contrato com dado pessoal só
          aparece por inteiro para quem participa dele.
        </Text>

        <Tabs
          size="small" activeKey={aba} onChange={setAba}
          items={[
            // `key` no componente: trocar de aba remonta a lista, porque as
            // duas fazem consultas diferentes do mesmo dado — sem isso a
            // Vigências mostraria o resultado da consulta sem filtro.
            { key: 'contratos', label: 'Contratos',
              children: <PainelContratos key="todos" /> },
            { key: 'vigencias', label: 'Vigências',
              children: <PainelContratos key="vigencias" soVigencias /> },
          ]}
        />
      </div>
    </AntApp>
  );
}
